import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  showTypeFieldAction,
  udpateTypeFieldAction,
} from "../../Actions/TypeFieldAction/TypeFieldAction";
import { RxCross2 } from "react-icons/rx";
import { MdSaveAlt } from "react-icons/md";

const UpdateTypeFieldModal = ({ id, closeModal }) => {
  const showTypeField = useSelector((state) => state.showTypeField);
  const dispatch = useDispatch();
  const { typeFields } = showTypeField;
  const updateTypeField = useSelector((state) => state.updateTypeField);
  const { error } = updateTypeField;
  useEffect(() => {
    dispatch(showTypeFieldAction(id));
  }, []);
  const [state, setState] = useState({
    id: "",
    name: "",
    label: "",
    placeholder: "",
    type: "",
  });
  useEffect(() => {
    if (typeFields == undefined) {
      return;
    }
    setState({
      ...state,
      id: typeFields.id,
      name: typeFields.name,
      label: typeFields.label,
      placeholder: typeFields.placeholder,
      type: typeFields.type,
    });
  }, [typeFields]);
  const handleStateChange = (event) => {
    const { name, value } = event.target;
    setState({
      ...state,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(
      udpateTypeFieldAction(
        state.id,
        state.name,
        state.label,
        state.placeholder,
        state.type,
        id
      )
    );
  };
  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-container lg:w-6/12">
          <div className="modal-header ">
            <p
              className="cursor-pointer  text-xl text-red-500"
              onClick={closeModal}
            >
              <RxCross2 />
            </p>
          </div>
          <form action="">
            <div className="grid gap-2 grid-cols-1 lg:grid-cols-2">
              <div className="flex flex-col ">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  className="input"
                  onChange={handleStateChange}
                  value={state.name}
                />
                <p className="text-red-500">{error && error.name}</p>
              </div>

              <div className="flex flex-col ">
                <label htmlFor="name">Placeholder</label>
                <input
                  type="text"
                  name="placeholder"
                  id="placeholder"
                  className="input"
                  onChange={handleStateChange}
                  value={state.placeholder}
                />
                <p className="text-red-500">{error && error.placeholder}</p>
              </div>

              <div className="flex flex-col ">
                <label htmlFor="name">label</label>
                <input
                  type="text"
                  name="label"
                  id="label"
                  className="input"
                  onChange={handleStateChange}
                  value={state.label}
                />
                <p className="text-red-500">{error && error.label}</p>
              </div>

              <div className="flex flex-col ">
                <label htmlFor="type">type</label>
                <select
                  name="type"
                  onChange={handleStateChange}
                  value={state.type}
                  className="input"
                  id="type"
                >
                  <option value="">Select Type</option>
                  {["dropdown"].map((dropdown, index) => {
                    return (
                      <option key={index} value={dropdown}>
                        {dropdown}
                      </option>
                    );
                  })}
                </select>
                <p className="text-red-500">{error && error.type}</p>
              </div>
            </div>
            <button
              onClick={handleSubmit}
              className="btn-info  mt-2 flex gap-1  items-center"
            >
              Save <MdSaveAlt />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateTypeFieldModal;
